require("./exploremore.scss");

window.addEventListener("load", () => {
    var exploreMorelist = $("[data-role=exploremore-list]");
    $(exploreMorelist).slick({
        infinite: false,
        slidesToShow: 4,
        slidesToScroll: 4,
        dots: true,
        customPaging: function (slider, i) {
            return '<button type="button" role="tab"  data-webm-clickvalue="carousel-dots-explore-more"></button>';
        },
        prevArrow: '<button class="slick-prev slick-arrow" aria-label="Previous" type="button"  aria-disabled="false"  data-webm-clickvalue="carousel-prev-explore-more">PREVIOUS</button>',
        nextArrow: '<button class="slick-next slick-arrow" aria-label="Next" type="button"  aria-disabled="false"  data-webm-clickvalue="carousel-next-explore-more">NEXT</button>',
        responsive: [
            {
                breakpoint: 700,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    dots: true,
                    arrows: false
                }
            },
            {
                breakpoint: 992,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2,
                    dots: true,
                    arrows: false
                }
            },
            {
                breakpoint: 1336,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 3,
                    dots: true
                }
            }
        ]
    });
});